import { localDayKey } from "../../utils/dayKey";
import { localIsoFromDateTime } from "../tasks/taskUi";

export type OrderTimeType = "ASAP" | "EXACT" | "WINDOW";

/** When a scheduled order is due: its day and its time rule. */
export interface OrderWhen {
  day: string;
  timeType: OrderTimeType;
  timeFrom: string;
  timeUntil: string;
}

export function defaultOrderWhen(): OrderWhen {
  return {
    day: localDayKey(new Date()),
    timeType: "ASAP",
    timeFrom: "12:00",
    timeUntil: "14:00",
  };
}

/**
 * The create-order fields for an OrderWhen. Real UTC instants (the house
 * helper the CRM form uses) — a timezone-naive string parses in the SERVER's
 * zone, which shifted every kiosk pickup time by the UTC offset.
 */
export function orderWhenPayload(when: OrderWhen) {
  return {
    timeType: when.timeType,
    scheduledDate: when.day,
    scheduledFor:
      when.timeType !== "ASAP"
        ? localIsoFromDateTime(when.day, when.timeFrom)
        : undefined,
    scheduledUntil:
      when.timeType === "WINDOW"
        ? localIsoFromDateTime(when.day, when.timeUntil)
        : undefined,
  };
}
